/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;




//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-messageformat-parser/index.js
// module id = 965
// module chunks = 60